import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';


export default {
	name: 'Auto-Handover-Inbound',
	components: {
		BasicSelect,
		VueElementLoading,
		Paginate
	},
	data: function() {
		return {
			batchNo:'',
			batchNoErrorMSG:'',
			isLoadingSearch:false,
			isLoadingMPS:false,
			isLoadingBag:false,
			isLoadingAWB:false,
			BatchData:[],
			modalShow: false,
			modalShowecom:false,
			checkedType:'cargo',
			isEcom:true,
			IsInscanBag:false,
			isInscanSuccess:false,
			PaperBagbarcode:'',
			PaperBagErrorMSG:'',
			AWBsbarcode:'',
			AWBsErrorMSG:'',
			ConfirmationModalinscan : false,
			showConfirminscan: false,
			showConfirmecom:false,
			Confirmationecom:false,
			confirmBagHandover:'',
			mpsdata:[],
			bagdata:[],
			timeoutHandler: 0,
			inputString:'',
			manualInput : false,
			batchid:'',
			createdBy:'',
			CurrentHubName:'',
			PaperBagNo:'',
			ParentAWBDetails:[],
			MPScount:0,
			disablescanInBtn:true,
			isLoadingconfirm:false,
			batchinscan:'',
			autohandoverbatchid:'',
			totalCount:0,
			pageCount:0,
			pageNo: 0,
			limit:10,
			Bagcount:0,
			inscanparentawb:[],
			obsoletebagData :[],
			obsoleteCount :0,
			updatedBagCount:0,
			obseleteFlag :false,
			obsoletebagList:[],
			obsoleteAwbsList:[],
			ObsoleteAWBCount:0,
			UpdatedBatchMpsCount:0,
			isLoadingBagsorAwbs:false,
			isCountZero:true,
			istcpl:false,
			dualScanEcomOpen: false,
			dualScanCargoOpen: false,
			dualScanBags: [],
			dualScanAwbGroups: [],
			dualScanCounters: {
				TotalActive: 0,
				PendingCount: 0,
				ScannedCount: 0,
				ShortageCount: 0
			},
			dualScanBatchId: '',
			dualScanExpectedCount: 0,
			dualScanBagInput: '',
			dualScanBagError: '',
			dualScanPaperbagInput: '',
			dualScanPaperbagError: '',
			dualScanAwbInput: '',
			dualScanAwbError: '',
			dualScanMpsInput: '',
			dualScanMpsError: '',
			dualScanActiveAwb: '',
			dualScanExpandedAwb: '',
			// HUB-8058: hybrid cargo UI — flat MPS store + tab filters
			dualScanCargoMainTab: 'mps',
			dualScanMpsListTab: 'pending',
			dualScanMpsRows: [],
			dualScanMpsScannedMounted: false,
			dualScanMpsShortageMounted: false,
			selectedMpsKey: null,
			dualScanMpsWindowStart: 0,
			dualScanMpsWindowEnd: 50,
			dualScanScanBusy: false,
			dualScanListLoading: false,
			selectedShortageRow: null,
			dualScanAutoConfirmedMsg: '',
			dualScanSector: null,
			shortageModalOpen: false,
			shortageMode: '',
			shortageContext: null,
			shortageReasonCode: '',
			shortageSaveBusy: false,
			shortageReasons: [],
			shortageReasonsLoaded: false,
			shortageReasonsError: false,
			shortageReasonsFetching: false
		}
	},
	created: function() {},
	computed: {
		// HUB-8058: cargo MPS list filtered by verification sub-tab
		dualScanMpsFiltered(){
			const tab = this.dualScanMpsListTab;
			return this.dualScanMpsRows.filter(m => {
				if(tab === 'pending') return m.status === 'Pending';
				if(tab === 'scanned') return m.status === 'InScan';
				if(tab === 'shortage') return m.status === 'Shortage';
				return false;
			});
		},
		dualScanMpsUseWindow(){
			return this.dualScanMpsListTab === 'pending' && this.dualScanMpsFiltered.length > 80;
		},
		dualScanMpsWindowedRows(){
			const list = this.dualScanMpsFiltered;
			if(!this.dualScanMpsUseWindow) return list;
			return list.slice(this.dualScanMpsWindowStart, this.dualScanMpsWindowEnd);
		},
		dualScanMpsTopSpacerPx(){
			return this.dualScanMpsUseWindow ? this.dualScanMpsWindowStart * 44 : 0;
		},
		dualScanMpsBottomSpacerPx(){
			if(!this.dualScanMpsUseWindow) return 0;
			return (this.dualScanMpsFiltered.length - this.dualScanMpsWindowEnd) * 44;
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail[0].email;
		this.currenthubid =userdetail[0].HubId[0];
		this.$refs.batchNo.focus();
		this.globalSearch();
		this.fetchShortageReasons();
	},
	methods: {
		checkBarcode(e){
		if (this.timeoutHandler) {
		clearTimeout(this.timeoutHandler)
		this.inputString += String.fromCharCode(e.keyCode)
		}
		this.timeoutHandler = setTimeout(() => {
			if (this.inputString.length <= 3) {
				this.manualInput = true
				this.inputString = ''
			}else{
				this.manualInput = false
				this.inputString = ''
			}
		}, 10)
	},

	globalSearch() {
		this.BatchData =[]
		if (this.checkedType == "cargo") {
			this.isEcom = false
		}
		if (this.checkedType == "ecom") {
			this.isEcom = true
		}
		this.isLoadingSearch =true;
		axios({
			method: "GET",
			'url': apiUrl.api_url_hubops + 'SearchBatch?isEcom=' + this.isEcom + "&currentHubId=" + this.currenthubid ,
			headers: {
				'authorization': 'authkey xB84JJ89Hd25',
				'requestfrom': "WEB",
				'token': this.token
			}
		}).then(result => {
			this.isLoadingSearch =false;
			let response = result.data;
			if (response.ResultCode == 100) {
				this.$alertify.success(response.ReturnMessage)
				this.BatchData = response.ResponseData;
				this.CurrentHubName = response.CurrentHubName;
			}else{
				this.$alertify.error(response.ReturnMessage);
			}
		}, error => {
			console.error(error);
			this.isLoadingSearch =false;
		})
	},


	getObsoleteBags(data){
		this.isLoadingBagsorAwbs = true;
		this.obsoletebagData =[];
		this.obseleteFlag = false;
		this.obsoleteCount = 0;
		this.updatedBagCount = 0;
		this.obsoletebagList =[];
		axios({
			method: "GET",
			'url': apiUrl.api_url_hubops + 'getObsoleteBagListForBatch?batchid=' + data.batchid + "&currentHubId=" + this.currenthubid ,
			headers: {
				'authorization': 'authkey xB84JJ89Hd25',
			}
		}).then(result => {
			this.isLoadingBagsorAwbs = false;
			let response = result.data;
			if (response.ResultCode == 100 && response.ResponseData) {
				this.obseleteFlag = true;
				this.obsoletebagData = response.ResponseData;
				this.obsoleteCount = response.ObsoleteBagCount;
				this.updatedBagCount = response.UpdatedBatchCount;
				if(response.UpdatedBatchCount > 0 ){
                     this.isCountZero = false;
				}
				this.openInscanCardecom(data);
				this.obsoletebagData.map(row=>{
					this.obsoletebagList.push(row.bagno);
				})

			}else{
				//this.$alertify.error(result.data.ReturnMessage);
				if(data.Bagcount > 0){
				   this.isCountZero = false;
				}
				this.openInscanCardecom(data);

			}
		}, error => {
			console.error(error);
			this.isLoadingBagsorAwbs = false;
		})
	},


	getObsoleteAwbs(data){
		this.obseleteFlag = false;
		this.IsInscanBag= false;
		this.istcpl = (data.istcpl) ? data.istcpl : false;
		this.obsoleteAwbsList = [];
		this.ObsoleteAWBCount= 0;
		this.UpdatedBatchMpsCount = 0;
		this.isLoadingBagsorAwbs = true;

		let url = apiUrl.api_url_hubops + 'getObsoleteAWBListForBatch?batchid=' + this.batchinscan + "&currentHubId=" + this.currenthubid;
		if(this.PaperBagbarcode){
			url =  url + "&paperbagno="+ this.PaperBagbarcode
		}else{
			url = url + "&istcpl=" + data.istcpl
		}

		axios({
			method: "GET",
			'url': url,
			headers: {
				'authorization': 'authkey xB84JJ89Hd25',
			}
		}).then(result => {
			this.isLoadingBagsorAwbs = false;
			let response = result.data;
			if (response.ResultCode == 100 && response.ResponseData) {
				this.obseleteFlag = true;
				this.obsoleteAwbsList = response.ResponseData;
				this.ObsoleteAWBCount= response.ObsoleteAWBCount;
				this.UpdatedBatchMpsCount = response.UpdatedBatchMpsCount;
				if(response.UpdatedBatchMpsCount > 0){
					this.isCountZero = false;
			   }
				this.closeInscanCard();
				this.openConfirmationModalinscan(true);

			}else{
				//this.$alertify.error(result.data.ReturnMessage);
				if(this.MPScount > 0){
					this.isCountZero = false;
				}

				if(data.istcpl) {
					this.openConfirmationModalinscan(true);
				}else{
					this.getconfirmation();
				}
			}
		}, error => {
			console.error(error);
			this.isLoadingBagsorAwbs = false;
		})
	},




	searchBatchNo() {
			if (this.batchNo == '' || this.batchNo== undefined) {
				this.batchNoErrorMSG = 'Enter batchNo';
				return false;
			}
			if (this.checkedType == "cargo") {
				this.isEcom = false
			}
			this.isLoadingSearch =true;
			axios({
				method: "GET",
				'url': apiUrl.api_url_hubops + 'SearchBatch?searchParam=' + this.batchNo + "&isEcom=" + this.isEcom + "&currentHubId=" + this.currenthubid ,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
					'requestfrom': "WEB",
					'token': this.token
				}
			}).then(result => {
				this.isLoadingSearch =false;
				let response = result.data;
				if (response.ResultCode == 100) {
					this.$alertify.success(response.ReturnMessage)
					this.BatchData = response.ResponseData;
					this.CurrentHubName = response.CurrentHubName
				}else{
					this.$alertify.error(response.ReturnMessage);
				}
			}, error => {
				console.error(error);
				this.isLoadingSearch =false;
			})
	},

	bmodalopen(data) {
		this.batchid = data.batchid,
		this.createdBy = data.createdby,
		this.getMPSDetails()
		this.modalShow = true;
	},

	bmodalclose() {
		this.batchid='',
		this.createdBy='',
		this.modalShow = false;
	},

	bmodalopenecom(data) {
		this.batchid = data.batchid,
		this.createdBy = data.createdby,
		this.totalCount = data.Bagcount,
		this.getBAGDetails()
	    this.modalShowecom = true;
    },

	bmodalcloseecom() {
		this.batchid='',
		this.createdBy='',
	this.modalShowecom = false;
},

	  getMPSDetails(){
		this.mpsdata=[],
		this.isLoadingMPS =true;
		axios({
			method: "GET",
			'url': apiUrl.api_url_hubops + 'getMPSNo?BatchNo=' + this.batchid + "&createdBy=" + this.createdBy ,
			headers: {
				'authorization': 'authkey xB84JJ89Hd25',
			}
		}).then(result => {
			this.isLoadingMPS =false;
			let response = result.data;
			if (response.ResultCode == 100 && response.ResponseData) {
				this.mpsdata = response.ResponseData;
			}else{
				this.$alertify.error(result.data.ReturnMessage);
			}
		}, error => {
			console.error(error);
			this.isLoadingMPS =false;
		})
	},

	getBAGDetails(){
		this.bagdata=[],
 		this.isLoadingMPS =true;
 		axios({
			method: "GET",
	 		'url': apiUrl.api_url_hubops + 'getBagListForB2C?batchid=' + this.batchid + "&limit=" + this.limit + "&offset=" + this.pageNo,
	 		headers: {
				'authorization': 'authkey xB84JJ89Hd25',
			}
		}).then(result => {
			this.isLoadingMPS =false;
	 	let response = result.data;
	 	if (response.ResultCode == 100 ) {
		 	this.bagdata = response.ResponseData;
			if (this.totalCount < 10) {
				this.pageCount = 1
			} else {
				this.pageCount = Math.ceil(this.totalCount / 10);
			}
	 }else{
		 this.$alertify.error(result.data.ReturnMessage);
	 }
 }, error => {
	 console.error(error);
	 this.isLoadingMPS =false;
 })
},

  getPaginationData(pageNum) {
			this.pageNo = 0
			this.pageNo = (pageNum - 1);
			this.getBAGDetails();
		},

		inscanBag() {
			if (!this.PaperBagbarcode) {
				this.PaperBagErrorMSG = 'PaperBagbarcode is required.';
				return false;
			}
			this.PaperBagNo='',
			this.ParentAWBDetails=[],
			this.input = ({
				paperBagNo:this.PaperBagbarcode,
				currenthubid:this.currenthubid,
				lastmodifiedby:this.useremail,
				currenthubname:this.CurrentHubName,
				autohandoverbatchid:this.autohandoverbatchid
			})
			this.isLoadingBag =true;
			axios({
				method: "PUT",
				'url': apiUrl.api_url_hubops + 'paperBagInScan',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			}).then(result => {
				this.isLoadingBag =false;
				let response = result.data;
				if (response.ResultCode == 100) {
				this.ParentAWBDetails = response.ResponseData;
				this.PaperBagNo=response.PaperBagNo;
				this.disablescanInBtn= false
				this.$alertify.success(response.ReturnMessage)
				}else{
					this.ParentAWBDetails=[];
					this.PaperBagNo='';
					this.$alertify.error(response.ReturnMessage);
				}
			}, error => {
				console.error(error);
				this.isLoadingBag =false;
			})
		},

		inscanAwbpaper() {
			if (!this.PaperBagNo) {
				this.PaperBagErrorMSG = 'Inscan Paper bag first.';
				return false;
			}
			if (!this.AWBsbarcode) {
				this.AWBsErrorMSG = 'AWBs is required.';
				return false;
			}
			this.inscanparentawb=[];
			this.input = ({
				parentawb:this.AWBsbarcode,
				paperBagNo:this.PaperBagNo,
				currenthubid:this.currenthubid,
				LastModifiedBy:this.useremail,
				currenthubname:this.CurrentHubName
			})
			this.isLoadingAWB =true;
			axios({
				method: "PUT",
				'url': apiUrl.api_url_hubops + 'Awbpaperbaginscan',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			}).then(result => {
				this.isLoadingAWB =false;
				let response = result.data;
				if (response.ResultCode == 100) {
					this.$alertify.success(response.ReturnMessage)
					this.inscanparentawb = response;
					this.ParentAWBDetails.forEach(inscan=>{
		        if(inscan.parentawb == this.inscanparentawb.ParentAWB){
		          inscan.inscandone = true;
		        }
		      });
					return this.ParentAWBDetails;
				}else{
					this.$alertify.error(response.ReturnMessage);
				}
			}, error => {
				console.error(error);
				this.isLoadingAWB =false;
			})
		},

		openInscanCard(data){
			this.batchinscan = data.batchid
			this.MPScount = data.MPScount
			this.autohandoverbatchid = data.autohandoverbatchid
			if(data.isDualScanEnabled){
				this.openDualScanCargo(data);
				return;
			}
			if(data.istcpl){
				this.getObsoleteAwbs(data);
			}else{
				this.IsInscanBag= true;
			}
		},

		closeInscanCard() {
			this.isInscanSuccess = false;
			this.IsInscanBag = false;
			this.obseleteFlag = false;
			this.resetinscan();
		},

		openInscanCardecom(data){
			this.batchinscan = data.batchid;
			this.Bagcount = data.Bagcount;
			if(data.isDualScanEnabled){
				this.openDualScanEcom(data);
				return;
			}
			this.showConfirmecom = true;
			this.Confirmationecom = true;
		},


		closeInscanCardecom() {
			 this.Confirmationecom= false;
			 this.showConfirmecom = false;
			 },


			 AutoHandoverInscanB2C() {


	 			this.input = ({
	 				batchid:this.batchinscan,
	 				currentHubId:this.currenthubid,
	 				createdBy:this.useremail,
	 				currentHubName:this.CurrentHubName,
					obsolete_bagnos:this.obsoletebagList,
	 			})
	 			this.isLoadingSearch =true;
	 			axios({
	 				method: "POST",
	 				'url': apiUrl.api_url_hubops + 'AutoHandoverInscanB2C',
	 				'data': this.input,
	 				headers: {
	 					'authorization': 'authkey xB84JJ89Hd25',
	 				}
	 			}).then(result => {
	 				this.isLoadingSearch =false;
	 				let response = result.data;
	 				if (response.ResultCode == 100) {
	 					this.$alertify.success(response.ReturnMessage)
	 					this.closeInscanCardecom();
	 					this.globalSearch();
	 				}else{
	 					this.$alertify.error(response.ReturnMessage);
	 				}
	 			}, error => {
	 				console.error(error);
	 				this.isLoadingSearch =false;
	 			})
	 		},

		closeInscanCard() {
			this.isInscanSuccess = false
			this.IsInscanBag = false
			this.resetinscan();
		},

		openConfirmationModalinscan(data) {
			this.showConfirminscan = data;
			this.ConfirmationModalinscan = true;
		},

		getconfirmation(){
		this.isLoadingconfirm =true;
		axios({
			method: "GET",
			'url': apiUrl.api_url_hubops + 'ahinscanconfirm?autohandoverbatchid=' + this.autohandoverbatchid  ,
			headers: {
				'authorization': 'authkey xB84JJ89Hd25',
			}
		}).then(result => {
			this.isLoadingconfirm =false;
			let response = result.data;
			if (response.ResultCode == 100 ) {
				this.closeInscanCard();
				this.openConfirmationModalinscan(true);
			}else{
				this.$alertify.error(response.ReturnMessage);
			}
		}, error => {
			console.error(error);
			this.isLoadingconfirm =false;
		})
	},


		ahbatchIncan() {
			this.input = ({
				batchid:this.batchinscan,
				currentHubId:this.currenthubid,
				lastModifiedBy:this.useremail,
				currentHubName:this.CurrentHubName,
				obsoleteAWBList:this.obsoleteAwbsList,
				istcpl: this.istcpl
			})
			this.isLoadingSearch =true;
			axios({
				method: "PUT",
				'url': apiUrl.api_url_hubops + 'ahbatchIncan',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			}).then(result => {
				this.isLoadingSearch =false;
				let response = result.data;
				if (response.ResultCode == 100) {
					this.$alertify.success(response.ReturnMessage)
					this.closeConfirmationModalinscan();
					this.globalSearch();
				}else{
					this.$alertify.error(response.ReturnMessage);
				}
			}, error => {
				console.error(error);
				this.isLoadingSearch =false;
			})
		},


		closeConfirmationModalinscan() {
			 this.ConfirmationModalinscan= false;
			 this.showConfirminscan = false;
			 this.obseleteFlag = false;
			 },

		resetForm(){
			this.globalSearch();
			this.ParentAWBDetails=[];
			this.inscanparentawb=[];
			this.PaperBagNo='';
			this.PaperBagErrorMSG='',
			this.AWBsErrorMSG='',
			this.PaperBagbarcode='',
			this.AWBsbarcode='',
			this.isLoadingSearch =false;
			this.isLoadingMPS=false;
			this.isLoadingBag=false;
			this.isLoadingAWB=false;
			this.isLoadingconfirm=false;
			this.disablescanInBtn=true;
			this.autohandoverbatchid='';
			this.totalCount=0;
			this.pageNo= 0;
			this.bagdata=[];
			this.Bagcount=0;
			this.closeInscanCard();
			this.obsoletebagData =[];
			this.obsoleteCount = 0;
			this.updatedBagCount = 0;
			this.obseleteFlag =false;
			this.obsoletebagList=[];
			this.obsoleteAwbsList=[];
			this.ObsoleteAWBCount= 0;
		    this.UpdatedBatchMpsCount= 0;
			this.isLoadingBagsorAwbs = false;
			this.isCountZero = true;
		
			
		},

		resetinscan(){
			this.ParentAWBDetails=[];
			this.inscanparentawb=[];
			this.PaperBagNo='';
			this.PaperBagErrorMSG='',
			this.AWBsErrorMSG='',
			this.PaperBagbarcode='',
			this.AWBsbarcode='',
			this.isLoadingSearch =false;
			this.isLoadingMPS=false;
			this.isLoadingBag=false;
			this.isLoadingAWB=false;
			this.isLoadingconfirm=false;
			this.disablescanInBtn=true;
			this.$validator.reset();
		},

		checkField(){
			this.globalSearch();
			this.CurrentHubName='',
			this.isLoadingSearch =false;
			this.ParentAWBDetails=[];
			this.inscanparentawb=[];
			this.mpsdata=[],
			this.PaperBagNo='';
			this.batchNoErrorMSG = '';
			this.batchNo = ''
			this.PaperBagbarcode=''
			this.disablescanInBtn=true
			this.$validator.reset();

		},

		// HUB-8058: fetch shortage reason master once per session, cache in-memory
		// HUB-8058: fetch shortage reason master. Cached in-memory after first
		// successful load. Re-callable on failure (the loaded flag only flips
		// on success, so a subsequent call retries). openShortageModal and the
		// inline panel's Retry button both drive this.
		fetchShortageReasons(){
			if(this.shortageReasonsLoaded || this.shortageReasonsFetching) return;
			this.shortageReasonsFetching = true;
			this.shortageReasonsError = false;
			axios({
				method: "GET",
				'url': apiUrl.api_url_hubops + 'getComboHubShortageReasonMaster',
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.shortageReasonsFetching = false;
				let response = result.data;
				if(response.ResultCode == 100 && Array.isArray(response.ResponseData) && response.ResponseData.length > 0){
					this.shortageReasons = response.ResponseData;
					this.shortageReasonsLoaded = true;
					this.shortageReasonsError = false;
				}else{
					this.shortageReasonsError = true;
				}
			}, error => {
				this.shortageReasonsFetching = false;
				console.error('fetchShortageReasons failed', error);
				this.shortageReasonsError = true;
			});
		},

		// HUB-8058: called by the inline shortage panel's Retry button when the
		// mount-time fetch silently failed (Redis miss + auth blip + etc.).
		// Resets both flags so fetchShortageReasons will actually re-attempt.
		retryFetchShortageReasons(){
			this.shortageReasonsLoaded = false;
			this.shortageReasonsError = false;
			this.fetchShortageReasons();
		},

		// HUB-8058: convert reason code to human label using cached master
		shortageReasonLabel(code){
			if(!code) return '';
			const match = this.shortageReasons.find(r => r.code === code);
			return match ? match.label : code;
		},

		// HUB-8058: patch counters + AutoConfirmed handling from a scan/shortage response.
		// AutoConfirmed no longer closes the modal - it shows a persistent success
		// banner and refreshes the batch table in the background. Rationale: the
		// abrupt close was disorienting for ground staff, and Confirm InScan is
		// redundant with server-side auto-confirm anyway, so it was removed. The
		// user closes manually via the Close button.
		//
		// Server contract asymmetry (intentional, matches APK expectation):
		//   - Cargo endpoints (getMPSNo, AutoHandoverMPSInScan,
		//     markShipmentShortageForBatch) return TotalActiveMPS.
		//   - Ecom  endpoints (getBagListForB2C, AutoHandoverBagInScan,
		//     markBagShortageForBatch)         return TotalActiveBags.
		// The other three counters (PendingCount / ScannedCount / ShortageCount)
		// use unified names on both sides. Normalise the total-active field
		// here so the modal shows correct "Scanned X / Y" and "N pending" text.
		applyCounterEnvelope(res){
			if(res){
				const total = res.TotalActive !== undefined      ? res.TotalActive
				            : res.TotalActiveMPS !== undefined   ? res.TotalActiveMPS
				            : res.TotalActiveBags !== undefined  ? res.TotalActiveBags
				            : undefined;
				if(total !== undefined){
					this.dualScanCounters.TotalActive  = total;
					this.dualScanCounters.PendingCount = res.PendingCount;
					this.dualScanCounters.ScannedCount = res.ScannedCount;
					this.dualScanCounters.ShortageCount= res.ShortageCount;
				}
			}
			if(res && res.AutoConfirmed){
				this.dualScanAutoConfirmedMsg =
					res.ReturnMessage || 'Batch InScan processed successfully';
				this.globalSearch();
			}
		},

		// HUB-8058: Ecom dual-scan
		openDualScanEcom(data){
			this.dualScanBatchId = data.batchid;
			this.batchinscan = data.batchid;
			this.createdBy = data.createdby;
			this.dualScanExpectedCount = data.Bagcount || 0;
			this.dualScanBags = [];
			this.dualScanCounters = { TotalActive: 0, PendingCount: 0, ScannedCount: 0, ShortageCount: 0 };
			this.dualScanBagInput = '';
			this.dualScanBagError = '';
			this.selectedShortageRow = null;
			this.dualScanAutoConfirmedMsg = '';
			this.dualScanSector = null;
			this.dualScanEcomOpen = true;
			this.loadDualScanBags();
		},

		loadDualScanBags(){
			this.dualScanListLoading = true;
			axios({
				method: "GET",
				'url': apiUrl.api_url_hubops + 'getBagListForB2C?batchid=' + this.dualScanBatchId + '&limit=500&offset=0',
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.dualScanListLoading = false;
				let response = result.data;
				if(response.ResultCode == 100){
					// HUB-8058: DB status for a pending bag is 'OutScan' (see
					// autohandoverbatchdetails). Normalise to 'Pending' at the
					// mapping layer so the template + local mutations speak one
					// vocabulary ('Pending' / 'InScan' / 'BagShortage').
					this.dualScanBags = (response.ResponseData || []).map(row => ({
						bagno: row.bagno,
						status: row.status === 'OutScan' ? 'Pending' : row.status,
						isInScan: row.isInScan,
						comment: row.comment || '',
						bagtype: row.bagtype,
						groupno: row.groupno,
						groupname: row.groupname
					}));
					this.dualScanCounters.TotalActive  = response.TotalActiveBags !== undefined ? response.TotalActiveBags : (this.dualScanBags.length);
					this.dualScanCounters.PendingCount = response.PendingCount !== undefined ? response.PendingCount : this.dualScanBags.filter(b => b.status === 'Pending').length;
					this.dualScanCounters.ScannedCount = response.ScannedCount !== undefined ? response.ScannedCount : this.dualScanBags.filter(b => b.status === 'InScan').length;
					this.dualScanCounters.ShortageCount= response.ShortageCount!== undefined ? response.ShortageCount: this.dualScanBags.filter(b => b.status === 'BagShortage').length;
				}else if(response.ResultCode == 101){
					this.dualScanBags = [];
				}else{
					this.$alertify.error(response.ReturnMessage);
				}
			}, error => {
				this.dualScanListLoading = false;
				console.error(error);
			});
		},

		applyDualScanSectorFromResponse(response) {
			if (response.Sector && typeof response.Sector === 'object' && response.Sector.Primary_Sector) {
				this.dualScanSector = response.Sector;
			} else {
				this.dualScanSector = null;
			}
		},

		canScanCargoMpsDual() {
			if (!this.PaperBagNo || !this.dualScanActiveAwb) {
				return false;
			}
			const grp = this.dualScanAwbGroups.find((g) => g.parentawb === this.dualScanActiveAwb);
			return !!(grp && grp.parentawbstatus === 'InScan');
		},

		scanBagDual(){
			if(!this.dualScanBagInput){ this.dualScanBagError = 'Scan a bag'; return; }
			if(this.dualScanScanBusy) return;
			this.dualScanBagError = '';
			this.dualScanScanBusy = true;
			const bagno = this.dualScanBagInput;
			axios({
				method: "POST",
				'url': apiUrl.api_url_hubops + 'AutoHandoverBagInScan',
				'data': {
					batchid: this.dualScanBatchId,
					bagNo: bagno,
					currentHubId: this.currenthubid,
					currentHubName: this.CurrentHubName,
					createdBy: this.useremail
				},
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.dualScanScanBusy = false;
				const response = result.data;
				if(response.ResultCode == 100){
					// Patch matching row in-place
					const idx = this.dualScanBags.findIndex(b => b.bagno === bagno);
					if(idx >= 0){
						this.dualScanBags[idx].status = 'InScan';
						this.dualScanBags[idx].isInScan = true;
					}
					this.applyDualScanSectorFromResponse(response);
					this.applyCounterEnvelope(response);
					if(response.AlreadyScanned){
						this.$alertify.warning('Already scanned');
					}else{
						this.$alertify.success(response.ReturnMessage || 'Bag inscanned');
					}
					this.dualScanBagInput = '';
					this.$nextTick(() => { if(this.$refs.dualScanBagInput) this.$refs.dualScanBagInput.focus(); });
				}else{
					this.$alertify.error(response.ReturnMessage || 'Scan failed');
					this.dualScanBagInput = '';
					this.$nextTick(() => { if(this.$refs.dualScanBagInput) this.$refs.dualScanBagInput.focus(); });
				}
			}, error => {
				this.dualScanScanBusy = false;
				console.error(error);
				this.dualScanBagError = 'Scan failed';
			});
		},

		closeDualScanEcom(){
			this.dualScanEcomOpen = false;
			this.dualScanBags = [];
			this.dualScanBagInput = '';
			this.dualScanBagError = '';
			this.dualScanSector = null;
			this.selectedShortageRow = null;
		},

		// HUB-8058: Cargo dual-scan
		openDualScanCargo(data){
			this.dualScanBatchId = data.batchid;
			this.batchinscan = data.batchid;
			this.createdBy = data.createdby;
			this.dualScanExpectedCount = data.MPScount || 0;
			this.dualScanAwbGroups = [];
			this.dualScanCounters = { TotalActive: 0, PendingCount: 0, ScannedCount: 0, ShortageCount: 0 };
			this.dualScanPaperbagInput = '';
			this.dualScanPaperbagError = '';
			this.dualScanAwbInput = '';
			this.dualScanAwbError = '';
			this.dualScanMpsInput = '';
			this.dualScanMpsError = '';
			this.dualScanActiveAwb = '';
			this.dualScanExpandedAwb = '';
			this.dualScanCargoMainTab = 'mps';
			this.dualScanMpsListTab = 'pending';
			this.dualScanMpsRows = [];
			this.dualScanMpsScannedMounted = false;
			this.dualScanMpsShortageMounted = false;
			this.selectedMpsKey = null;
			this.resetDualScanMpsWindow();
			this.selectedShortageRow = null;
			this.dualScanAutoConfirmedMsg = '';
			this.dualScanSector = null;
			this.PaperBagNo = '';
			this.ParentAWBDetails = [];
			this._dualScanMpsById = {};
			this.dualScanCargoOpen = true;
		},

		rebuildDualScanMpsMap(){
			this._dualScanMpsById = {};
			this.dualScanMpsRows.forEach(r => { this._dualScanMpsById[r.mpsid] = r; });
		},

		findMpsRow(mpsid){
			return this._dualScanMpsById ? this._dualScanMpsById[mpsid] : null;
		},

		patchMpsRow(mpsid, patch){
			const row = this.findMpsRow(mpsid);
			if(row) Object.assign(row, patch);
			this.dualScanAwbGroups.forEach(g => {
				g.mps.forEach(m => {
					if(m.mpsid === mpsid) Object.assign(m, patch);
				});
			});
		},

		mpsRowKey(row){
			return row.parentawb + '||' + row.mpsid;
		},

		setDualScanCargoMainTab(tab){
			this.dualScanCargoMainTab = tab;
			if(tab === 'parent-awbs') this.selectedMpsKey = null;
		},

		setDualScanMpsListTab(tab){
			this.dualScanMpsListTab = tab;
			if(tab === 'scanned') this.dualScanMpsScannedMounted = true;
			if(tab === 'shortage') this.dualScanMpsShortageMounted = true;
			this.selectedMpsKey = null;
			this.resetDualScanMpsWindow();
		},

		resetDualScanMpsWindow(){
			this.dualScanMpsWindowStart = 0;
			this.dualScanMpsWindowEnd = 50;
		},

		onDualScanMpsListScroll(e){
			if(!this.dualScanMpsUseWindow) return;
			const el = e.target;
			const rowH = 44;
			const start = Math.floor(el.scrollTop / rowH);
			const visible = Math.ceil(el.clientHeight / rowH) + 8;
			this.dualScanMpsWindowStart = Math.max(0, start - 4);
			this.dualScanMpsWindowEnd = Math.min(this.dualScanMpsFiltered.length, start + visible + 4);
		},

		syncParentAwbStatusOnRows(parentawb, status){
			this.dualScanMpsRows.forEach(r => {
				if(r.parentawb === parentawb) r.parentawbstatus = status;
			});
			const grp = this.dualScanAwbGroups.find(g => g.parentawb === parentawb);
			if(grp) grp.parentawbstatus = status;
		},

		scanPaperbagDual(){
			if(!this.dualScanPaperbagInput){ this.dualScanPaperbagError = 'Scan paperbag'; return; }
			this.dualScanPaperbagError = '';
			this.isLoadingBag = true;
			axios({
				method: "PUT",
				'url': apiUrl.api_url_hubops + 'paperBagInScan',
				'data': {
					paperBagNo: this.dualScanPaperbagInput,
					currenthubid: this.currenthubid,
					lastmodifiedby: this.useremail,
					currenthubname: this.CurrentHubName,
					autohandoverbatchid: this.autohandoverbatchid
				},
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.isLoadingBag = false;
				const response = result.data;
				if(response.ResultCode == 100){
					this.PaperBagNo = response.PaperBagNo;
					this.ParentAWBDetails = response.ResponseData || [];
					this.$alertify.success(response.ReturnMessage);
					this.loadDualScanMPS();
					this.$nextTick(() => { if(this.$refs.dualScanAwbInput) this.$refs.dualScanAwbInput.focus(); });
				}else{
					this.$alertify.error(response.ReturnMessage);
					this.dualScanPaperbagInput = '';
				}
			}, error => {
				this.isLoadingBag = false;
				console.error(error);
			});
		},

		scanAwbDual(){
			if(!this.PaperBagNo){ this.dualScanPaperbagError = 'Inscan paperbag first'; return; }
			if(!this.dualScanAwbInput){ this.dualScanAwbError = 'Scan AWB'; return; }
			this.dualScanAwbError = '';
			this.isLoadingAWB = true;
			axios({
				method: "PUT",
				'url': apiUrl.api_url_hubops + 'Awbpaperbaginscan',
				'data': {
					parentawb: this.dualScanAwbInput,
					paperBagNo: this.PaperBagNo,
					currenthubid: this.currenthubid,
					LastModifiedBy: this.useremail,
					currenthubname: this.CurrentHubName
				},
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.isLoadingAWB = false;
				const response = result.data;
				if(response.ResultCode == 100){
					this.$alertify.success(response.ReturnMessage);
					this.ParentAWBDetails.forEach(a => { if(a.parentawb === response.ParentAWB) a.inscandone = true; });
					this.syncParentAwbStatusOnRows(response.ParentAWB, 'InScan');
					this.dualScanExpandedAwb = response.ParentAWB;
					this.loadDualScanMPS();
					this.dualScanAwbInput = '';
					this.$nextTick(() => { if(this.$refs.dualScanMpsInput) this.$refs.dualScanMpsInput.focus(); });
				}else{
					this.$alertify.error(response.ReturnMessage);
					this.dualScanAwbInput = '';
				}
			}, error => {
				this.isLoadingAWB = false;
				console.error(error);
			});
		},

		loadDualScanMPS(){
			this.dualScanListLoading = true;
			axios({
				method: "GET",
				'url': apiUrl.api_url_hubops + 'getMPSNo?BatchNo=' + this.dualScanBatchId + '&createdBy=' + this.createdBy,
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.dualScanListLoading = false;
				const response = result.data;
				if(response.ResultCode == 100){
					// HUB-8058: DB status for a pending MPS is 'OutScan' (see
					// autohandoverbatchdetails). Normalise to 'Pending' at the
					// mapping layer so the template + local mutations speak one
					// vocabulary ('Pending' / 'InScan' / 'Shortage'). Note the
					// row.parentawbstatus lookup below is unrelated - that's
					// paperwork-level state, legitimately 'OutScan' vs 'InScan'.
					const rows = (response.ResponseData || []).map(r => ({
						mpsid: String(r.mpsid || '').toLowerCase(),
						parentawb: r.parentawb,
						parentawbstatus: r.parentawbstatus || (this.ParentAWBDetails.find(a => a.parentawb === r.parentawb) && this.ParentAWBDetails.find(a => a.parentawb === r.parentawb).inscandone ? 'InScan' : 'OutScan'),
						status: r.status === 'OutScan' ? 'Pending' : r.status,
						isInScan: r.isInScan,
						comment: r.comment || ''
					}));
					// Group by parentawb for accordion display
					const groups = {};
					rows.forEach(r => {
						if(!groups[r.parentawb]) groups[r.parentawb] = { parentawb: r.parentawb, parentawbstatus: r.parentawbstatus, mps: [] };
						groups[r.parentawb].mps.push(r);
					});
					this.dualScanAwbGroups = Object.values(groups);
					this.dualScanMpsRows = rows;
					this.rebuildDualScanMpsMap();
					this.resetDualScanMpsWindow();
					this.dualScanCounters.TotalActive  = response.TotalActiveMPS !== undefined ? response.TotalActiveMPS : rows.length;
					this.dualScanCounters.PendingCount = response.PendingCount !== undefined ? response.PendingCount : rows.filter(r => r.status === 'Pending').length;
					this.dualScanCounters.ScannedCount = response.ScannedCount !== undefined ? response.ScannedCount : rows.filter(r => r.status === 'InScan').length;
					this.dualScanCounters.ShortageCount= response.ShortageCount!== undefined ? response.ShortageCount: rows.filter(r => r.status === 'Shortage').length;
					if(!this.dualScanExpandedAwb){
						const firstOpen = this.dualScanAwbGroups.find(g => g.parentawbstatus === 'InScan');
						if(firstOpen) this.dualScanExpandedAwb = firstOpen.parentawb;
					}
				}else if(response.ResultCode == 101){
					this.dualScanAwbGroups = [];
					this.dualScanMpsRows = [];
					this.rebuildDualScanMpsMap();
				}else{
					this.$alertify.error(response.ReturnMessage);
				}
			}, error => {
				this.dualScanListLoading = false;
				console.error(error);
			});
		},

		scanMpsDual(){
			if(!this.PaperBagNo){ this.dualScanMpsError = 'Inscan paperbag first'; return; }
			if(!this.dualScanMpsInput){ this.dualScanMpsError = 'Scan MPS'; return; }
			if(this.dualScanScanBusy) return;
			const mpsid = String(this.dualScanMpsInput).trim().toLowerCase();
			const row = this.findMpsRow(mpsid);
			if(!row){
				this.dualScanMpsError = 'MPS not in batch';
				return;
			}
			if(row.status !== 'Pending'){
				this.dualScanMpsError = row.status === 'InScan' ? 'Already scanned' : 'Not pending';
				return;
			}
			this.dualScanMpsError = '';
			this.dualScanScanBusy = true;
			const parentawb = row.parentawb;
			axios({
				method: "POST",
				'url': apiUrl.api_url_hubops + 'AutoHandoverMPSInScan',
				'data': {
					batchid: this.dualScanBatchId,
					paperBagNo: this.PaperBagNo,
					parentAWB: parentawb,
					mpsId: mpsid,
					currentHubId: this.currenthubid,
					currentHubName: this.CurrentHubName,
					createdBy: this.useremail
				},
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.dualScanScanBusy = false;
				const response = result.data;
				if(response.ResultCode == 100){
					this.patchMpsRow(mpsid, { status: 'InScan', isInScan: true });
					this.applyDualScanSectorFromResponse(response);
					this.applyCounterEnvelope(response);
					if(response.AlreadyScanned){
						this.$alertify.warning('Already scanned');
					}else{
						this.$alertify.success(response.ReturnMessage || 'MPS inscanned');
					}
					this.dualScanMpsInput = '';
					this.$nextTick(() => { if(this.$refs.dualScanMpsInput) this.$refs.dualScanMpsInput.focus(); });
				}else{
					this.$alertify.error(response.ReturnMessage || 'Scan failed');
					this.dualScanMpsInput = '';
					this.$nextTick(() => { if(this.$refs.dualScanMpsInput) this.$refs.dualScanMpsInput.focus(); });
				}
			}, error => {
				this.dualScanScanBusy = false;
				console.error(error);
			});
		},

		toggleAwbAccordion(parentawb){
			this.dualScanExpandedAwb = (this.dualScanExpandedAwb === parentawb) ? '' : parentawb;
		},

		closeDualScanCargo(){
			this.dualScanSector = null;
			this.dualScanCargoOpen = false;
			this.dualScanAwbGroups = [];
			this.dualScanMpsRows = [];
			this._dualScanMpsById = {};
			this.dualScanCargoMainTab = 'mps';
			this.dualScanMpsListTab = 'pending';
			this.dualScanMpsScannedMounted = false;
			this.dualScanMpsShortageMounted = false;
			this.selectedMpsKey = null;
			this.dualScanPaperbagInput = '';
			this.dualScanAwbInput = '';
			this.dualScanMpsInput = '';
			this.selectedShortageRow = null;
			this.PaperBagNo = '';
			this.ParentAWBDetails = [];
		},

		// HUB-8058: shortage marking - row selection is driven by a native
		// <input type="radio"> per Pending row, wrapped inside a <label>
		// (so clicking anywhere on the row selects the radio). v-model binds
		// selectedShortageRow directly, so no JS click-handler layer is
		// required. This removed the "Mark shortage stuck disabled" class of
		// bugs that plagued the inline @click expression pattern under
		// Bootstrap-Vue modal chrome.

		// HUB-8058: openShortageModal / closeShortageModal now toggle an
		// INLINE shortage panel embedded inside each InScan modal body, not
		// a standalone <b-modal>. Two reasons:
		//   (1) Nested Bootstrap-Vue modals stack backdrops, and closing the
		//       inner modal (Cancel) sometimes strips the parent's ARIA state,
		//       leaving the screen unresponsive under a lingering backdrop.
		//   (2) Modal-on-modal hides the scan context (list + counters) the
		//       operator needs to see while confirming shortage - inline
		//       keeps everything on screen.
		// The state variable name (shortageModalOpen) is kept for minimal
		// diff churn; treat it as "shortagePanelOpen" semantically.
		openShortageModal(mode){
			if(mode === 'ecom' && this.selectedShortageRow === null) return;
			if(mode === 'cargo' && !this.selectedMpsKey) return;
			let ctx = null;
			if(mode === 'ecom'){
				const row = this.dualScanBags[this.selectedShortageRow];
				if(!row || row.status !== 'Pending') return;
				ctx = { bagno: row.bagno };
			}else if(mode === 'cargo'){
				if(!this.selectedMpsKey) return;
				const parts = String(this.selectedMpsKey).split('||');
				const row = this.findMpsRow(parts[1]);
				if(!row || row.parentawb !== parts[0] || row.status !== 'Pending') return;
				ctx = { mpsid: row.mpsid, parentawb: row.parentawb };
			}
			this.shortageMode = mode;
			this.shortageContext = ctx;
			this.shortageReasonCode = '';
			this.shortageModalOpen = true;
			// If reason master never loaded (mount-time fetch dropped or failed
			// silently), re-attempt now so the operator isn't stranded with an
			// empty dropdown.
			if(!this.shortageReasonsLoaded) this.fetchShortageReasons();
		},

		closeShortageModal(){
			this.shortageModalOpen = false;
			this.shortageMode = '';
			this.shortageContext = null;
			this.shortageReasonCode = '';
		},

		saveShortage(){
			if(!this.shortageReasonCode){ this.$alertify.error('Select a reason'); return; }
			if(this.shortageSaveBusy) return;
			this.shortageSaveBusy = true;
			const endpoint = this.shortageMode === 'ecom' ? 'markBagShortageForBatch' : 'markShipmentShortageForBatch';
			const payload = {
				batchid: this.dualScanBatchId,
				reasonCode: this.shortageReasonCode,
				currentHubId: this.currenthubid,
				currentHubName: this.CurrentHubName,
				createdBy: this.useremail
			};
			if(this.shortageMode === 'ecom'){
				payload.bagNo = this.shortageContext.bagno;
			}else{
				payload.paperBagNo = this.PaperBagNo;
				payload.parentAWB = this.shortageContext.parentawb;
				payload.mpsId = this.shortageContext.mpsid;
			}
			axios({
				method: "POST",
				'url': apiUrl.api_url_hubops + endpoint,
				'data': payload,
				headers: { 'authorization': 'authkey xB84JJ89Hd25' }
			}).then(result => {
				this.shortageSaveBusy = false;
				const response = result.data;
				if(response.ResultCode == 100){
					if(this.shortageMode === 'ecom'){
						const idx = this.dualScanBags.findIndex(b => b.bagno === this.shortageContext.bagno);
						if(idx >= 0){
							this.dualScanBags[idx].status = 'BagShortage';
							this.dualScanBags[idx].comment = this.shortageReasonCode;
						}
						this.applyCounterEnvelope(response);
					}else{
						this.patchMpsRow(this.shortageContext.mpsid, {
							status: 'Shortage',
							comment: this.shortageReasonCode
						});
						this.applyCounterEnvelope(response);
					}
					this.$alertify.success(response.ReturnMessage || 'Shortage marked');
					this.selectedShortageRow = null;
					this.selectedMpsKey = null;
					this.closeShortageModal();
				}else{
					this.$alertify.error(response.ReturnMessage || 'Shortage failed');
				}
			}, error => {
				this.shortageSaveBusy = false;
				console.error(error);
			});
		}

		// HUB-8058: confirmDualScanBatch was removed in favour of server-side
		// auto-confirm. When AutoConfirmed=true comes back on the final scan or
		// shortage response, applyCounterEnvelope surfaces the success banner
		// and background-refreshes the batch table. Close is user-driven.
	}


}



// WEBPACK FOOTER //
// ./src/views/components/AutoHandover_v1/Inbound/Inbound.js